module.exports = __webpack_public_path__ + "img/banner.5689d4d2.png";